import { PropType } from "vue";
import { CTableProps } from "./type";
export default {
  data: Array as PropType<CTableProps["data"]>,
  columns: Array as PropType<CTableProps["columns"]>,
};
